import { render } from "./ServicesDetailsIoT.vue?vue&type=template&id=a8d2cbc2"
import script from "./ServicesDetailsIoT.vue?vue&type=script&lang=js"
export * from "./ServicesDetailsIoT.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__